import React, { Component } from 'react';
import { Link } from "react-router-dom";

import 'react-bootstrap';

class Breadcrumb extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    componentDidUpdate() {

    }

    componentWillReceiveProps(newProps) {

    }

    render() {

        return (
            <section className="ftco-services-2 ftco-no-pt" id="breadcrumb">
                <hr className="solid tall" />
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="portfolio-title">
                                <div className="row">
                                    <div className="col-md-12 heading-section">
                                        {
                                            this.props.showTitle &&
                                            <h2 className="mb-none mt-2 figure fadeIn animated"
                                                style={{ textIndent: localStorage.getItem('language') === 'cn' ? '21.25pt' : '14.5pt' }}
                                                data-animate="fadeIn" dangerouslySetInnerHTML={{ __html: this.props.pageTitle }}></h2>
                                        }
                                        {this.props.placeTitle !== null ?
                                            <div className="figure pull-right fadeIn animated" data-animate="fadeIn">
                                                <Link to="/destination" className="portfolio-nav-all breadcrumb-item">
                                                    <div className="mb-none">{this.props.businessTitle}</div>
                                                </Link>
                                                <Link to={this.props.url + '/' + this.props.placeID} className="portfolio-nav-all breadcrumb-item">
                                                    <div className="mb-none" dangerouslySetInnerHTML={{ __html: this.props.placeTitle }}>
                                                    </div>
                                                </Link>
                                                <span className="portfolio-nav-all breadcrumb-item">
                                                    <div className="mb-none" dangerouslySetInnerHTML={{ __html: this.props.pageTitle }}>
                                                    </div>
                                                </span>
                                            </div>
                                            :
                                            <div className="figure pull-right fadeIn animated" data-animate="fadeIn">
                                                <Link to="/destination" className="portfolio-nav-all breadcrumb-item">
                                                    <div className="mb-none"><span className="">{this.props.businessTitle}</span></div>
                                                </Link>
                                                <span className="portfolio-nav-all breadcrumb-item">
                                                    <div className="mb-none" dangerouslySetInnerHTML={{ __html: this.props.pageTitle }}>
                                                    </div>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Breadcrumb;